<template>
  <div>
    <x-grid
      :id="'formList'"
      :rowId="rowId"
      :pager-config="pagerConfig"
      :form-config="formConfig"
      :url="url"
      :columns="columns"
      :checkbox-config="checkboxConfig"
      :toolbar-config="toolbarConfig"
      :print-config="printConfig"
      :export-config="exportConfig"
      ref="grid"
      :cellClick="chooseRow"
      :cellDbClick="updateRow"
      @toolbar-addData="addRow"
      @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button
          status="primary"
          v-auth="`UPDATEPWD`"
          @click="chooseOpenPop('password')"
          >设置新密码</vxe-button>

        <vxe-button
          status="primary"
          v-auth="`ACCREDIT`"
          @click="merchants"


          >商家授权</vxe-button
        >
        <vxe-button status="primary" v-auth="`CREATE`" @click="createAccount()">生成商城账号</vxe-button>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
      title="用户管理"
      centered
      :closable="false"
      :footer="null"
      :maskClosable="false"
      :visible="editModalVisible"
      :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
        :rowId="editRowId"
        v-if="editModalVisible"
        ref="detailForm"
        @cancelled="closeEdit()"
        @saved="closeEdit(true)"
      >
      </detailForm>
    </a-modal>

    <!--  设置密码  -->
    <a-modal
      title="设置新密码"
      centered
      :maskClosable="false"
      :visible="popConfig.password.show"
      :closable="false"
      :footer="null"
      :width="600"
    >
      <setPassword
        ref="setPassword"
        :rowId="popConfig.password.id"
        :row="popConfig.password.row"
        :type="'password'"
        @cancelled="closePop('password')"
        @saved="closeEdit(true)"
      >
      </setPassword>
    </a-modal>

  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import { GridMixin } from "@/utils/GridMixin";
import { formatter as fmt } from "@/utils/ebase-formatter";
import api from "@/services/api";
import { loadBaseCodeData } from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除

// import {dataApi} from '@/services/comm/userManage';
// console.log(dataApi)

import detailForm from "@/pages/web/comm/userManage/userManageDetail";

//弹出层组件
import setPassword from "@/pages/web/comm/userManage/list/setPassword";
import { mapState } from "vuex";
import {dataApi} from "@/services/comm/ecMemberManage";
// import user from "@/services/user";

const fac = XGrid.factory;

//列表接口
const url = api.client.FOLLOWUP;

//主键
const rowId = "followId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("custId", "客户编号", 140),
  fac.makeColumn("followUserId", "跟进人编号", 140),
  fac.makeColumn("remark", "备注", 120, "center"),
  fac.makeColumn("createDate", "创建时间", 160, "center"),
  // fac.makeColumn("mobile", "手机号", 160, "center"),
  // fac.makeColumn("lastLoginTime", "最后登录时间", 160, "center"),
  // fac.makeColumn("createUserName", "创建人", 100, "center"),
  // fac.makeColumn("lastModifyUserName", "最后修改人", 100, "center"),
  // fac.makeColumn("lastModifyDate", "最后修改时间", 160, "center"),
  // fac.makeColumn("remark", "备注", 300),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  { field: "userNo" },
  { field: "userName" },
  // {field: 'email'},
  {
    field: "isUse",
    type: "select",
    options: [
      { label: "全部", value: "" },
      { label: "是", value: 1 },
      { label: "否", value: "0" },
    ],
  },
  { field: "deptName" },
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

const popConfig = fac.makePopConfig(["password","merchantsAuthorization"]);

export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm,
    setPassword,
  },
  computed: {
    ...mapState("account", { currUser: "user" }),
  },
  data() {
    return {
      popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList:[]
    };
  },
  methods: {
    async createAccount(){
      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
      if (rows.length != 1) {
        this.$message.error('请选择一条数据');
        return;
      }
      console.log(rows)
      const userId=rows[0].userId
      console.log(userId)
      await dataApi.accountNumber(userId).then((res) => {
        if (res.code===200){
          this.$message.success(res.msg);
        }else {
          this.$message.error(res.msg)
        }
        console.log(res)
        this.refresh();
      }).catch(e => {
        console.log(e);
      })
    },
     merchants(){

      let rows = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
       console.log(rows)

       this.userIdList = rows.map((i) => {
         return i.userId;
       }).join(',')
       console.log(this.userIdList)
       this.chooseOpenPop('merchantsAuthorization',1)
    },
    closeLog(){
      this.logModalVisible = false;
    },
  },
};
</script>

<style scoped>
</style>